/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  ButtonBase,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Menu,
  MenuItem,
} from '@material-ui/core';
import { Close, MoreHoriz } from '@material-ui/icons';
import { deleteClasse, getClassesById, generateCode } from '@webapps/business';
import {
  Button,
  useMutation,
  useQuery,
  useRouter,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Modal, { default as ModalStep } from 'components/Modal';
import { ROUTES_PATH } from 'config/constants';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import ShareClassroom from './ShareClassroom';

import NewClasses from './NewClasses';

const ActionClasse = ({ from, id, nbrStudent, refetch, handleOpenExportModal, className }) => {
  const { classes, css, global, cx, theme: { } } = useStyles(styles);
  const history = useHistory();

  const intl = useIntl();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openCreateClasses, setOpenCreateClasses] = useState(false);
  const [openDeleteClasses, setOpenDeleteClasses] = useState(false);
  const [openGenerateCode, setOpenGenerateCode] = useState(false);
  const [openShareClassroom, setOpenShareClassroom] = useState(false);
  const [generatedCode, setGeneratedCode] = useState(null);
  const { addToast } = useToast();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const { data: classe = {} } = useQuery(getClassesById, {
    key: ['classe', id],
    variables: { id },
  });

  const handleOpenCreateClasses = () => {
    setOpenCreateClasses(true);
  };

  const handleCloseCreateClasses = () => {
    setOpenCreateClasses(false);
  };

  const handleOpenDeleteClasses = () => {
    setOpenDeleteClasses(true);
  };

  const handleCloseDeleteClasses = () => {
    setOpenDeleteClasses(false);
  };

  const {
    isLoading: isLoadingDeleteClasse,
    isSuccess: isSuccessDeleteClasse,
    mutateAsync: mutateDeleteClasse,
  } = useMutation(deleteClasse);

  const handleDeleteclasse = () => {
    mutateDeleteClasse({
      id,
    });
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(generatedCode);
    addToast({
      status: 'success',
      message: 'Code copié dans le presse-papier',
    });
  };

  const {
    isSuccess: isSuccessGenerateCode,
    mutateAsync: mutateGenerateCode,
  } = useMutation(generateCode);

  const handleGenerateCode = async () => {
    try {
      const response = await mutateGenerateCode({
        id,
        data: {
          type: 'classroom',
        },
      });

      setGeneratedCode(response.data.code);
      setOpenGenerateCode(true);
      refetch();
    } catch (error) {
      addToast({
        status: 'error',
        message: 'Erreur lors de la génération du code',
      });
    }
  };

  useEffect(() => {
    if (isSuccessDeleteClasse) {
      addToast({
        status: 'success',
        message: 'Opération réussie',
      });
      refetch();
      handleCloseDeleteClasses();
      handleClose();
      if (from === 'item') {
        history.goBack();
      }
    }
  }, [isSuccessDeleteClasse]);

  const { params, push } = useRouter();

  const { id: idParam } = params;

  const goToStudentListExclu = () => {
    push(ROUTES_PATH.STUDENT_EXCLUD, { params: { id: idParam } });
  };

  const goToStudentListAbandoned = () => {
    push(ROUTES_PATH.STUDENT_ABANDONED, { params: { id: idParam } });
  };

  // const handleExport = async () => {
  //   console.log("Exporting");

  //   try {
  //     console.log('Exporting statement for classes:', selectedClasses);

  //     const { data } = await exportClassroomsStatement.query({
  //       classroomIds: [id],
  //       startDate: new Date(startYear, startMonth - 1, 1).toISOString().split("T")[0],
  //       endDate: new Date(endYear, endMonth, 0).toISOString().split("T")[0],
  //     });

  //     fetch(`${process.env.NX_PROXY_API}/export`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         data: data,
  //         includeAllStudents: false
  //       }),
  //     })
  //     .then(response => response.blob())
  //     .then(blob => {
  //       const url = window.URL.createObjectURL(blob);
  //       const a = document.createElement('a');
  //       a.href = url;
  //       a.download = blob.type.includes('zip') ? 'export.zip' : 'export.xlsx';
  //       document.body.appendChild(a);
  //       a.click();
  //       document.body.removeChild(a);
  //     })


  //     if (onClose) onClose();

  //   } catch (error) {
  //     console.error('Error exporting statement:', error);
  //   }
  // };

  return (
    <div className={className}>
      <ButtonBase onClick={handleClick} style={{ margin: '0px 3px', alignSelf: 'baseline', borderRadius: '20px', border: '1px solid #C0D9FF', backgroundColor: '#F3F7FF', width: '26px', display: 'flex', justifyContent: 'center', height: '26px', alignItems: 'center', cursor: 'pointer' }}>
        <MoreHoriz fontSize="small" onClick={handleClick} style={{ color: '#5A6DA1', fontSize: '15.00px' }} />
      </ButtonBase>
      <Menu
        anchorEl={anchorEl}
        id="candidature-menu"
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{ elevation: 2 }}
        transformOrigin={{ horizontal: 'left', vertical: -50 }}
        anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
      >
        <MenuItem disableRipple disableFocusRipple onClick={handleGenerateCode}>Générer un code</MenuItem>
        <MenuItem disableRipple disableFocusRipple onClick={() => setOpenShareClassroom(true)}>Partager ma classe</MenuItem>
        {handleOpenExportModal && <MenuItem disableRipple disableFocusRipple onClick={() => handleOpenExportModal(id)}>Télécharger le relevé</MenuItem>}
        <MenuItem disableRipple disableFocusRipple onClick={handleOpenCreateClasses}>Modifier</MenuItem>
        <MenuItem disableRipple disableFocusRipple onClick={handleOpenDeleteClasses}>Supprimer</MenuItem>
        {/* <MenuItem onClick={goToStudentListExclu}>
          Etudiant(s) supprimé(s)
        </MenuItem>
        <MenuItem onClick={goToStudentListAbandoned}>
          Etudiant(s) abandonné(s)
        </MenuItem> */}
      </Menu>
      <Modal
        nbStep={1}
        onCancel={handleCloseCreateClasses}
        open={openCreateClasses}
        step={1}
        title="Modifier la classe"
        withStep={false}
      >
        <NewClasses
          close={handleCloseCreateClasses}
          data={classe}
          refetch={refetch}
        />
      </Modal>
      <Dialog
        BackdropProps={{
          style: {
            backgroundColor: 'rgba(0, 45, 117, 0.6)',
          },
        }}
        classes={{
          paperScrollPaper: css({
            width: '100%',
            maxWidth: 500,
            borderRadius: 10,
            position: 'relative',
            overflow: 'visible',
          }),
        }}
        onClose={handleCloseDeleteClasses}
        open={openDeleteClasses}
      >
        <IconButton
          className={css({
            position: 'absolute',
            background: '#045ff9',
            color: 'white',
            top: -10,
            right: -10,
            '&:hover': {
              background: '#045ff9',
              color: 'white',
            },
          })}
          onClick={handleCloseDeleteClasses}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
        <DialogTitle
          className={css({ background: '#045ff9', borderTopLeftRadius: 10 })}
          id="alert-dialog-title"
        >
          Suppression de la classe
        </DialogTitle>
        <DialogContent>
          {nbrStudent > 0
            ? 'Cette classe contient déjà des étudiants'
            : 'Êtes-vous sûr de vouloir supprimer'}
        </DialogContent>
        <DialogActions>
          {nbrStudent > 0 ? (
            <Button
              color="primary"
              onClick={handleCloseDeleteClasses}
              variant="outlined"
            >
              Fermer
            </Button>
          ) : (
            <>
              <Button
                color="primary"
                onClick={handleCloseDeleteClasses}
                variant="outlined"
              >
                Annuler
              </Button>
              <Button
                autoFocus
                color="primary"
                disabled={isLoadingDeleteClasse}
                onClick={handleDeleteclasse}
                variant="contained"
              >
                Supprimer
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
      <Modal
        onCancel={() => setOpenGenerateCode(false)}
        open={openGenerateCode}
        title="Votre nouveau code d’invitation :"
        withStep={false}
      >
        <div className={classes.copyToClipboardContainer}>
          <div className={cx(global.subTitle, classes.subTitle)}>Appuyez sur le bouton pour copier le code</div>
          <div className={cx(global.subTitle, classes.subTitle)}>(Votre code expire dans 31 jours)</div>
          <IconButton className={classes.copyToClipboard} onClick={copyToClipboard} color="primary">
            <FileCopyIcon className={classes.copyToClipboardIcon} /> {generatedCode}
          </IconButton>
        </div>
      </Modal>
      <Modal
        onCancel={() => setOpenShareClassroom(false)}
        open={openShareClassroom}
        title="Selectionnez les apprenants à partager"
        withStep={false}
        width={800}
      >
        <ShareClassroom id={id} onClose={() => setOpenShareClassroom(false)} />
      </Modal>
    </div>
  );
};

const styles = ({ spacing }) => ({
  copyToClipboard: {
    background: '#0060F9',
    color: 'white',
    borderRadius: 10,
    padding: spacing(1, 2, 1, 2),
    marginTop: spacing(2),
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 600,
    '&:hover': {
      background: '#0060F9',
      color: 'white',
    },
  },
  copyToClipboardContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: spacing(2),
  },
  copyToClipboardIcon: {
    marginRight: spacing(1),
    '@media only screen and (max-width:1920px)': { fontSize: '15.0px' },
    '@media only screen and (max-width:1600px)': { fontSize: '15px' },
  },
  subTitle: {
    width: '100%',
    textAlign: 'center',
  }
});

ActionClasse.propTypes = {
  id: PropTypes.number.isRequired,
  refetch: PropTypes.func,
  nbrStudent: PropTypes.number,
  from: PropTypes.string,
};

export default ActionClasse;
